import { createReducer, on } from '@ngrx/store';
import { FieldActions } from '../fields/fields.actions';
import { ImportActions } from './import.actions';
import { initialImportState } from './import.states';

export const importReducer = createReducer(
  initialImportState,

  on(ImportActions.openImportDialog, (state) => ({
    ...state,
    isImportDialogOpen: true,
  })),
  on(ImportActions.closeImportDialog, (state) => ({
    ...state,
    isLoaded: false,
    isImportDialogOpen: false,
    importedFields: [],
    fileParsingErrors: [],
  })),

  on(ImportActions.selectFileType, (state, { importHandler }) => ({
    ...state,
    importHandler: importHandler,
  })),

  on(ImportActions.resetFile, (state) => ({
    ...state,
    isLoaded: false,
    importedFields: [],
    fileParsingErrors: [],
    importFile: undefined,
  })),

  on(ImportActions.clearParsingError, (state, { filename }) => ({
    ...state,
    fileParsingErrors: state.fileParsingErrors.filter(
      (error) => error.filename !== filename
    ),
  })),
  on(ImportActions.clearAllParsingErrors, (state) => ({
    ...state,
    fileParsingErrors: []
  })),

  on(ImportActions.toggleFieldSelection, (state, { importKey }) => ({
    ...state,
    importedFields: state.importedFields.map((f) =>
      f.importKey === importKey ? { ...f, selected: !f.selected } : f
    ),
  })),

  on(ImportActions.setAllFieldSelections, (state, { selected }) => ({
    ...state,
    importedFields: state.importedFields.map((f) => ({ ...f, selected: selected })),
  })),

  on(FieldActions.fieldCreated, (state, { importKey }) => ({
    ...state,
    importedFields: state.importedFields.map((f) => ({
      ...f,
      isImported: importKey === f.importKey ? true : f.isImported,
    })),
  })),

  on(ImportActions.fieldsReceived, (state, { importedFields }) => ({
    ...state,
    isLoaded: true,
    importedFields: [...state.importedFields, ...importedFields],
  })),

  on(ImportActions.fileParsingError, (state, { filename, errorMessage }) => ({
    ...state,
    isLoaded: false,
    importedFields: [],
    fileParsingErrors: [...state.fileParsingErrors, { filename, errorMessage }],
  })),

  on(ImportActions.fieldsImported, (state, { importedFields }) => ({
    ...state,
    isLoaded: false,
    importedFields: [...state.importedFields, ...importedFields],
  })),

  on(ImportActions.fieldImportFailed, (state, { field, errorMessage }) => ({
    ...state,
    importedFields: state.importedFields.map((importedField) => ({
      ...importedField,
      hasError:
        importedField.field.name === field.name
          ? true
          : importedField.hasError,
      errorMessage:
        importedField.field.name === field.name
          ? errorMessage
          : importedField.errorMessage,
    })),
  })),
);
